import { render } from "./Keypoints.vue?vue&type=template&id=0c10cb52"
import script from "./Keypoints.vue?vue&type=script&lang=js"
export * from "./Keypoints.vue?vue&type=script&lang=js"

import "./Keypoints.vue?vue&type=style&index=0&id=0c10cb52&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__